'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { analytics } from './segment';
import { CanonicalConfiguration, getCanonicalPath } from '../url/get-canonical-url';

export function Analytics({
  canonicalConfigurations = [],
  metaProps = {},
}: {
  canonicalConfigurations: Array<CanonicalConfiguration>;
  metaProps?: Record<string, any>;
}) {
  const pathName = usePathname();
  const searchParams = useSearchParams();

  const metaStore: any = {};

  const actualPathName = getCanonicalPath(pathName, metaStore, canonicalConfigurations);

  useEffect(() => {
    analytics.page({
      path: actualPathName,
      ...metaStore,
      ...metaProps,
    });
  }, [pathName, searchParams]);

  return null;
}

export function track(
  eventType: string,
  options: Record<string, any> = {},
  userId?: string | null
) {
  const actualOptions: any = { ...options };
  if (userId) {
    actualOptions.user_id = userId;
  }
  analytics.track(eventType, actualOptions, userId ? { userId: userId as any } : {});
}
